<template>
    <div>
        <!-- 搜索 -->
        <div class="search">
            <div class="condition">
                <div class="condition-item">
                    <div class="label">班级名称:</div>
                    <a-input placeholder="请输入" v-model="queryParam.className" style="flex: 1;"
                        @keyup.enter="getClassSummary"></a-input>
                </div>
            </div>
            <a-button type="primary" @click="getClassSummary(true)">查询</a-button>
        </div>
        <!-- 表格 -->
        <div class="table">
            <a-table :columns="columns" :dataSource="tableData" class="c-table" :pagination="pagination"
                :rowKey="getRowKey" @change="tableChange">
                <template slot="parentName" slot-scope="text, record">
                    {{ record.parentName || '暂未填写' }}
                </template>
                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <a @click="check(record.classId)" style="color: #1890ff;" :disabled="record.participant == 0"
                        :class="{ 'gray': record.participant == 0 }">查看</a>
                </template>
            </a-table>
        </div>
        <!-- 班级详情 -->
        <QTableDetail v-if="showDetail" :showDetail.sync="showDetail" :classId="classId" :formId="formId">
        </QTableDetail>
    </div>
</template>

<script>
import { Empty } from 'ant-design-vue';
import questionnaire from '../../../api/questionnaire';
import QTableDetail from './QTableDetail.vue';
import Vue from 'vue';

const columns = [
    {
        title: '班级名称',
        dataIndex: 'className',
        key: 'className',
    },
    {
        title: '下发问卷量',
        dataIndex: 'totalStudent',
        key: 'totalStudent',
    },
    {
        title: '回收问卷量',
        dataIndex: 'participant',
        key: 'participant',
    },
    {
        title: '完成率',
        dataIndex: 'finished',
        key: 'finished',
    },
    {
        title: '综合得分',
        dataIndex: 'overallScore',
        key: 'overallScore',
    },
    {
        title: '课程得分',
        dataIndex: 'dimensionScoreAverage1',
        key: 'dimensionScoreAverage1',
    },
    {
        title: '教师得分',
        dataIndex: 'dimensionScoreAverage2',
        key: 'dimensionScoreAverage2',
    },
    {
        title: '客服得分',
        dataIndex: 'dimensionScoreAverage3',
        key: 'dimensionScoreAverage3',
    },
    {
        title: '平台得分',
        dataIndex: 'dimensionScoreAverage4',
        key: 'dimensionScoreAverage4',
    },
    {
        title: '教务得分',
        dataIndex: 'dimensionScoreAverage5',
        key: 'dimensionScoreAverage5',
    },
    {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
    },
]
export default {
    name: 'AnalyticsStatistics',
    props: {
        formId: {
            type: Number
        },
    },
    components: {
        QTableDetail,
    },
    data() {
        return {
            columns,
            tableData: [],
            pagination: {
                pageSize: 10,
                total: 0,
                showTotal: total => `总共 ${total} 条`, // 显示总数
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
                current: 1,
                currentPage: 1,
            }, //分页数据对象
            simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
            showDetail: false,
            studentId: null,
            queryParam: {},
            searchSchoolLoading: false,
        }
    },
    created() {
        this.getClassSummary();
    },
    mounted() {
    },
    methods: {
        // 班级统计表
        async getClassSummary(flag) {
            if (flag) {
                this.pagination.currentPage = 1;
                this.pagination.current = 1;
            }
            let params = {
                id: this.formId,
                currentPage: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
                className: this.queryParam.className ? this.queryParam.className : '',
                schoolId: Vue.ls.get('schoolId')
            }
            const { data } = await questionnaire.getClassSummary(params)
            console.log(data, '班级统计表')
            this.tableData = data.list
            this.pagination.total = data.pagination.total
            this.tableData.forEach(item => {
                item.finishedPer = item.participant ? (item.participant * 100 / item.totalStudent) : 0
                item.finished = item.finishedPer ? item.finishedPer.toFixed(2) + '%' : '0%'
                item.totalStudent = this.formattedNumber(item.totalStudent)
                item.participant = this.formattedNumber(item.participant)
            })
        },
        getRowKey(record, index) {
            return index;
        },
        // 数据加逗号
        formattedNumber(num) {
            return new Intl.NumberFormat('en-US').format(num);
        },
        // 统计下一页
        tableChange(pagination) {
            this.pagination.current = pagination.current
            this.pagination.currentPage = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.getClassSummary()
        },
        check(id) {
            this.showDetail = true
            this.classId = id
        },
    }
}
</script>

<style lang="less" scoped>
.search {
    margin-bottom: 25px;
    display: flex;
    align-items: center;

    .condition {
        display: flex;
    }

    .condition-item {
        display: flex;
        align-items: center;
        margin-right: 15px;

        .label {
            margin-right: 12px;
        }
    }

    .btn {
        height: 32px;
        padding-top: 5px;
    }

    .select-box {
        width: 200px;
    }
}

.gray {
    color: gray !important;
}
</style>